import React, { useEffect, useState } from 'react';
import { getPosts, getCategories } from '../api';
import PostCard from '../components/PostCard';

export default function Home({ settings }) {
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState('all');

  useEffect(() => {
    getPosts().then(setPosts).catch(() => {});
    getCategories().then(setCategories).catch(() => {});
  }, []);

  const filteredPosts = activeCategory === 'all'
    ? posts
    : posts.filter(p => String(p.category_id) === String(activeCategory));

  return (
    <>
      {/* Profile Header */}
      <div className="profile-header">
        <div className="profile-info">
          <h1><span>{settings.site_title}</span></h1>
          <div className="profile-stats">
            <div><strong>{posts.length}</strong><span>publicaciones</span></div>
          </div>
          <div className="profile-bio">
            Producción audiovisual · Creatividad sin límites
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="feed-tabs" style={{ flexWrap: 'wrap' }}>
        <button className={activeCategory === 'all' ? 'active' : ''} onClick={() => setActiveCategory('all')}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: 2 }}>
            <rect x="2" y="2" width="9" height="9"/><rect x="13" y="2" width="9" height="9"/>
            <rect x="2" y="13" width="9" height="9"/><rect x="13" y="13" width="9" height="9"/>
          </svg>
          TODAS
        </button>
        {categories.map(c => (
          <button key={c.id} className={String(activeCategory) === String(c.id) ? 'active' : ''} onClick={() => setActiveCategory(c.id)}>
            {c.name.toUpperCase()}
          </button>
        ))}
      </div>

      {/* Grid */}
      {filteredPosts.length === 0 ? (
        <div className="empty-state">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
            <polyline points="21 15 16 10 5 21"/>
          </svg>
          <p>No hay publicaciones en esta categoría</p>
        </div>
      ) : (
        <div className="feed-grid">
          {filteredPosts.map(p => <PostCard key={p.id} post={p} settings={settings} />)}
        </div>
      )}
    </>
  );
}
